<div class="overlay animated fadeIn" *ngIf="this.parent.hasSearchResults() || ClearGridQuestion || AskAddNewRFQasPOQuestion || AskAddNewRFQQuestion;" (click)="this.parent.closeSearchResults();"></div>
<div>
<div class="overlayTransparent" *ngIf="this.ShowETAAlternatives == true || this.ShowSearchResultsAlternatives == true || this.ShowFallbackSelection == true || this.ShowBrandCollateral == true || this.ShowBrandCollateralNewProduct == true;" (click)="CloseGridPopupsOverlay();">
</div> 

<div class="InfoQuestion animated fadeInDown" *ngIf="AskAddNewRFQasPOQuestion" style="width: 40%;left: 30%;">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="AskAddNewRFQasPOQuestion = false;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'AskAddNewRFQasPOQuestion' | translate }}
  </div>
  <div class="InfoQuestionBodyOrder">
    <p>{{ 'AskAddNewRFQasPOQuestionDescription' | translate }}</p>
    <p class="Disclaimer">{{'PurchaseOrderDisclaimer' | translate}}</p>

    <mat-form-field class="ReceptionProductsColDropDown" appearance="outline" [disabled]="this.parent.Cart?.DeliveryPreference?.BlockedForChange === true">
      <mat-label>{{ 'SelectDeliveryPrefference' | translate }}</mat-label>
      <mat-select name="SelectDeliveryPrefference" [(ngModel)]="this.parent.Cart.DeliveryPreference" [compareWith]="this.parent.compareFn">
        <mat-option *ngFor="let d of this.parent.CartMasterData.DeliveryPreferences" [value]="d" [matTooltip]="d.Description" matTooltipClass='neutral-tool-tip' [disabled]="this.parent.Cart?.DeliveryPreference?.BlockedForChange">
          {{d.Name}}
          <!-- <i class="material-icons DeliveryPreferenceCheck" *ngIf="d.ID == this.parent.Cart?.DeliveryPreference?.ID">check</i> -->
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="DeliveryPrefferenceBlockedForChange" *ngIf="this.parent.Cart?.DeliveryPreference?.BlockedForChange === true;">
      <i class="material-icons">info_outline</i>
      <span>{{this.parent.Cart?.DeliveryPreference?.BlockedForChangeDescription}}</span>
    </div>

    <div class="TextBoxTitle">{{'UIPartnerReferenceNumberDescription' | translate}} ({{'Recommended' | translate}})</div> 
    <mat-form-field appearance="outline" class="CentralTextBoxContainer">
      <mat-icon matPrefix color="warn" class="CartItemSummaryContainerIcon" [matTooltip]="'UIPartnerReferenceNumberDescription' | translate"  [matTooltipZIndex]="1000"  matTooltipClass='neutral-tool-tip'>
        info_outline
      </mat-icon>
      <mat-label>
        {{ 'UIPartnerReferenceNumber' | translate }} ({{ 'Recommended' | translate }})
      </mat-label>
      <input matInput type="text" style="color: #fd4f57;font-weight: 500;" [(ngModel)]="parent.OfferRequest.DebatorPO"/>
    </mat-form-field>
  </div>

  <div class="InfoQuestionCommands" style="padding-right: 5%;padding-left: 5%; height: auto; min-height: 50px; overflow:hidden;padding-bottom: 20px;" *ngIf="this.parent.Cart?.Status?.ID != 1;">
    <button *ngIf="this.parent.loading !== true;" style="background: #f60;" mat-raised-button color="primary" class="OrderButton" (click)="this.AddNewOfferRequest(false, this.parent.Cart);">
      <i class="material-icons">arrow_forward</i>
      {{ 'SendRFQ' | translate }}
    </button>
    <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="this.parent.loading === true;"></mat-spinner>
  </div>

  <div class="InfoQuestionCommands" style="padding-right: 5%;padding-left: 5%;height: auto; min-height: 50px; overflow:hidden;padding-bottom: 20px;" *ngIf="this.parent.Cart?.Status?.ID == 1;">
    <button *ngIf="this.parent.loading !== true;" mat-raised-button color="primary" class="OrderButton" (click)="this.AddNewOfferRequest(true, this.parent.Cart);">
      <i class="material-icons">arrow_forward</i>
      {{ 'SendPO' | translate }}
    </button>
    <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="this.parent.loading === true;"></mat-spinner>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="AskAddNewRFQQuestion" style="width: 40%;left: 30%;">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="AskAddNewRFQQuestion = false;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'AskAddNewRFQQuestion' | translate }}
  </div>
  <div class="InfoQuestionBodyOrder">
    <p>{{ 'AskAddNewRFQQuestionDescription' | translate }}</p>
    <p class="Disclaimer">{{'QuotationDisclaimer' | translate}}</p>

    <mat-form-field class="ReceptionProductsColDropDown" appearance="outline" [disabled]="this.parent.Cart?.DeliveryPreference?.BlockedForChange === true">
      <mat-label>{{ 'SelectDeliveryPrefference' | translate }}</mat-label>
      <mat-select name="SelectDeliveryPrefference" [(ngModel)]="this.parent.Cart.DeliveryPreference" [compareWith]="this.parent.compareFn">
        <mat-option *ngFor="let d of this.parent.CartMasterData.DeliveryPreferences" [value]="d" [matTooltip]="d.Description" matTooltipClass='neutral-tool-tip' [disabled]="this.parent.Cart?.DeliveryPreference?.BlockedForChange">
          {{d.Name}}
          <!-- <i class="material-icons DeliveryPreferenceCheck" *ngIf="d.ID == this.parent.Cart?.DeliveryPreference?.ID">check</i> -->
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="DeliveryPrefferenceBlockedForChange" *ngIf="this.parent.Cart?.DeliveryPreference?.BlockedForChange === true;">
      <i class="material-icons">info_outline</i>
      <span>{{this.parent.Cart?.DeliveryPreference?.BlockedForChangeDescription}}</span>
    </div>

    <div class="TextBoxTitle">{{'UIPartnerReferenceNumberDescription' | translate}} ({{'Recommended' | translate}})</div> 
    <mat-form-field appearance="outline" class="CentralTextBoxContainer">
      <mat-icon matPrefix color="warn" class="CartItemSummaryContainerIcon" [matTooltip]="'UIPartnerReferenceNumberDescription' | translate"  [matTooltipZIndex]="1000"  matTooltipClass='neutral-tool-tip'>
        info_outline
      </mat-icon>
      <mat-label>
        {{ 'UIPartnerReferenceNumber' | translate }} ({{ 'Recommended' | translate }})
      </mat-label>
      <input matInput type="text" style="color: #fd4f57;font-weight: 500;" [(ngModel)]="parent.OfferRequest.DebatorPO"/>
    </mat-form-field>
  </div>

  <div class="InfoQuestionCommands" style="padding-right: 5%;padding-left: 5%; height: auto; min-height: 50px; overflow:hidden;padding-bottom: 20px;" *ngIf="this.parent.Cart?.Status?.ID != 1;">
    <button *ngIf="this.parent.loading !== true;" style="background: #f60;" mat-raised-button color="primary" class="OrderButton" (click)="this.AddNewOfferRequest(false, this.parent.Cart);">
      <i class="material-icons">arrow_forward</i>
      {{ 'SendRFQ' | translate }}
    </button>
    <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="this.parent.loading === true;"></mat-spinner>
  </div>

  <div class="InfoQuestionCommands" style="padding-right: 5%;padding-left: 5%;height: auto; min-height: 50px; overflow:hidden;padding-bottom: 20px;" *ngIf="this.parent.Cart?.Status?.ID == 1;">
    <button *ngIf="this.parent.loading !== true;" mat-raised-button color="primary" class="OrderButton" (click)="this.AddNewOfferRequest(true, this.parent.Cart);">
      <i class="material-icons">arrow_forward</i>
      {{ 'SendPO' | translate }}
    </button>
    <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="this.parent.loading === true;"></mat-spinner>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ClearGridQuestion">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ClearGridQuestion = false;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'ClearGridQuestion' | translate }}
  </div>
  <div class="InfoQuestionBody">
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.loading" mat-raised-button class="InfoQuestionButton" (click)="ClearGridQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
    <button [disabled]="this.loading" mat-raised-button color="warn" class="InfoQuestionButton PrimaryButtonTheme" (click)="ClearGridQuestion = false;ClearGrid();">
      <i class="material-icons">close</i>
      {{ 'ClearGrid' | translate }}
    </button>
  </div>
</div>

<div class="WelcomeTitle">
  {{'PriceListWelcomeTitle' | translate}}
</div>

<div class="WelcomeInfoRow">
  <i class="material-icons">lightbulb_outline</i>
  <span>{{'AllPricesNetPrices' | translate}}</span>
</div>

<div class="WelcomeInfoRow">
  <i class="material-icons">lightbulb_outline</i>
  <span>{{'RFQBasicInfo' | translate}}</span>
</div>

<div class="WelcomeInfoRow">
  <i class="material-icons">lightbulb_outline</i>
  <span>{{'AllGreenPOPossibility' | translate}}</span>
</div>

<div class="ListPriceBrandsContainer">
  <div *ngIf="this.loadingBrandIcons != true;">
    <div [ngClass]="{'ImportantBrand': b.Rank > 0}" class="ListPriceBrand" *ngFor="let b of this.Brands; let i = index;" matTooltip="({{b.Name}}) {{'AvailableUntil' | translate}}: {{b.AvailabilityDateUI}}" matTooltipClass='neutral-tool-tip'>
      <div class="BrandImage">
        <img [src]="this.parent.BackendServiceUrl + b.LogoPath">
      </div>
    </div>
  </div>
  <div *ngIf="this.loadingBrandIcons == true;" class="brandSpinnerContainer">
    <mat-spinner class="brandSpinner" [diameter]="25"></mat-spinner>
  </div>
</div>

<!-- <div class="WelcomeMessage" *ngIf="this.ShowSearchProductsPageMessage == true && this.B2BHomePageMessage?.length > 0;">
  <div class="WelcomeMessageTitle unSelectable">
    <i class="material-icons">info_outline</i>
    {{'Notice' | translate}}
  </div>
  <div class="WelcomeMessageClose" (click)="CloseShowSearchProductsPageMessage();">
    <i class="material-icons">close</i>
  </div>
  <div class="WelcomeMessageBody">
    {{this.B2BHomePageMessage}}
  </div>
</div> -->

<div class="overlay dashOverlay" *ngIf="this.parent.itemOverlay == true;" (click)="this.parent.CloseItemOverlay();"></div>

<!-- <div class="B2BBodyTopSearchContainer">
    <p class="B2BBodyTopSearchContainerTitle">{{'SearchProducts' | translate}}</p>
    <div class="CentralSearchContainer">
      <mat-spinner *ngIf="loadingProducts" class="loadingProductsSpinner" [diameter]="25"></mat-spinner>
      <input type="text" class="CentralSearch" placeholder="ex: 6GK5005-0BA00-1AB2" (click)="InitializeSearchProduct();" [(ngModel)]="this.Filter.SearchTerm" matInput (ngModelChange)="this.searchTermUpdate.next($event)">
      <i class="material-icons" *ngIf="!(this.Filter?.SearchTerm?.length > 0) && !loadingProducts;">search</i>
      <i class="material-icons" style="color:red;" *ngIf="this.Filter?.SearchTerm?.length > 0 && !loadingProducts;" (click)="this.SearchTerm = ''; this.SearchedProducts.length = 0; this.Filter.SearchTerm = '';">close</i>
    
      <div class="CentralSearchResultsContainer" *ngIf="SearchedProducts?.length > 0;">
        <div *ngFor="let p of this.SearchedProducts;" class="CentralSearchResult" (click)="this.parent.AddNewCartItem(p); this.SearchedProducts = [];">
          {{p.FKBrandName}} {{p.ProductName}}
          <span *ngIf="p.ProductPartNumber?.length > 0 && p.ProductPartNumber != p.Name;">({{p.ProductPartNumber}})</span>
        </div>
      </div>
    </div>
</div> -->

<div class="ColorGuideContainer">

  <!-- <div class="ColorGuideContainerTitle">
    <i class="material-icons">info_outline</i>
    <span>{{'UsageInstructions' | translate}}</span>
  </div> -->

  <!-- <div class="ColorGuideRow">
    <div class="ColorGuide" style="background: #32aa3a;">
    </div>
    <div class="ColorGuideSpan" style="background: #d2fed2;">
      {{'ValidRow' | translate}}
    </div>
  </div> -->

  <!-- <div class="ColorGuideRow">
    <div class="ColorGuide" style="background: #aaa;">
    </div>
    <div class="ColorGuideSpan" style="background: #ddd;color: #000;">
      {{'InvalidRow' | translate}}
    </div>
  </div> -->

  <!-- <div class="ColorGuideRow">
    <div class="ColorGuide" style="background: #ff8987!important;">
    </div>
    <div class="ColorGuideSpan" style="background: #ff8987!important;color: #000;">
      {{'UnknownProduct' | translate}}
    </div>
  </div> -->

  <!-- <div class="ColorGuideRow">
    <div class="ColorGuide" style="background: #f60;">
    </div>
    <div class="ColorGuideSpan" style="background: #ffcaa1;color: #000;">
      {{'AwaitingSelectionRow' | translate}}
    </div>
  </div> -->
</div>

<div class="GridTotals" *ngIf="this.parent.Cart?.Currency?.ID > 0;">
   <span class="IntegerSpan" style="margin-right: 10px;">Total:</span> <span class="IntegerSpan">{{this.parent.Cart?.Total?.UITotalQtyPriceNOVAT?.Integer}}</span><span class="DecimalSpan">{{this.parent.Cart?.Total?.UITotalQtyPriceNOVAT?.Decimals}}</span><span class="IntegerSpan">{{this.parent.Cart?.Currency?.Name}}</span> 
   <div class="GridTotalsDisclaimerContainer" (mouseenter)="isHovering = true" (mouseleave)="isHovering = false">
      <div class="HoverContentContainer" *ngIf="isHovering">
        <p *ngFor="let a of this.parent.RelevantAgents">{{a.Email}} ({{a.Department?.Name}})</p>
      </div>
    <i class="material-icons">lightbulb</i>
    <i class="material-icons">email</i>
    <span class="GridTotalsDisclaimerContainerInfo">
      {{'ForEmailOrders' | translate}}: orders@foxline.ro
    </span>
   </div>
  </div>

<div class="GridCommandCenter">
 
  <!-- <button mat-stroked-button color="primary" class="AddRowsButton" style="color: #4d148c;" (click)="this.parent.ExportB2BGrid();">
    <i class="material-icons">downloading</i>
    <span>{{'DownloadExcel' | translate}}</span>
  </button> -->

  <button mat-stroked-button color="primary" class="AddRowsButton" style="color: #4d148c;margin-right: 1%;" (click)="this.exportToExcel();">
    <i class="material-icons">downloading</i>
    <span>{{'DownloadExcel' | translate}}</span>
  </button>

  <button mat-flat-button color="primary" class="AddRowsButton" style="background: #4d148c;margin-right: 1%;" (click)="this.parent.DownloadOfficialOfferPDF();">
    <i class="material-icons">attach_file</i>
    <span>{{'DownloadOfficialOffer' | translate}}</span>
  </button>

  <button disabled="true" mat-flat-button color="primary" style="margin-right: 1%;" class="AddRowsButton" *ngIf="this.parent.Cart?.Status?.ID == -1 || this.parent.Cart?.Status?.ID == 1;" matTooltip="{{this.parent.Cart?.Status?.Description}}" matTooltipClass='neutral-tool-tip'>
    <i class="material-icons">local_offer</i>
    <span>{{'SendRFQ' | translate}}</span>
  </button>

  <!-- <button (click)="this.OpenAskAddNewRFQQuestion();" mat-flat-button color="primary" class="AddRowsButton" style="background: #4d148c;margin-right: 1%;" *ngIf="this.parent.Cart?.Status?.ID == 1;">
    <i class="material-icons">local_offer</i>
    <span>{{'SendRFQ' | translate}}</span>
  </button> -->

  <button (click)="this.OpenAskAddNewRFQQuestion();" mat-flat-button color="primary" class="AddRowsButton" style="background: #4d148c;margin-right: 1%;" *ngIf="this.parent.Cart?.Status?.ID == 0;" matTooltip="{{this.parent.Cart?.Status?.Description}}" matTooltipClass='neutral-tool-tip'>
    <i class="material-icons">local_offer</i>
    <span>{{'SendRFQ' | translate}}</span>
  </button>

  <button disabled="true" mat-stroked-button color="primary" style="margin-right: 1%;" class="AddRowsButton" *ngIf="this.parent.Cart?.Status?.ID != 1;" matTooltip="{{this.parent.Cart?.Status?.Description}}" matTooltipClass='neutral-tool-tip'>
    <i class="material-icons">arrow_forward</i>
    <span>{{'SendPO' | translate}}</span>
  </button>

  <button (click)="this.OpenAskAddNewRFQasPOQuestion();" mat-stroked-button color="primary" class="AddRowsButton AddNewPOButton" style="color: #4d148c;margin-right: 1%;" *ngIf="this.parent.Cart?.Status?.ID == 1 && this.loadingProducts != true;" matTooltip="{{this.parent.Cart?.Status?.Description}}" matTooltipClass='neutral-tool-tip'>
    <i class="material-icons">arrow_forward</i>
    <span>{{'SendPO' | translate}}w</span>
  </button>

  <button mat-stroked-button color="primary" class="AddRowsButton" style="color: #fd4f57; float: right;" (click)="this.AskClearGridQuestion();">
    <i class="material-icons">close</i>
    <span>{{'ClearGrid' | translate}}</span>
  </button>

  <!-- <mat-form-field class="OfferPriorityStatusesSelect" appearance="outline">
    <mat-label>{{ 'SelectOfferPriority' | translate }}</mat-label>
    <mat-select name="Language" [compareWith]="parent.compareFn" [(ngModel)]="this.parent.OfferPriorityStatus">
      <mat-option *ngFor="let prio of this.parent.OfferPriorityStatuses; index as i" [value]="prio">
        {{prio.Name}}
      </mat-option>
    </mat-select>
  </mat-form-field> -->
</div>

<div class="OwnAGGridContainer" style="position: relative!important;">
  <ag-grid-angular
  class="ag-theme-alpine"
  style="width: 100%;"
  [gridOptions]="gridOptions"
  [rowData]="rowData"
  [columnDefs]="columnDefs"
  [defaultColDef]="defaultColDef"
  (cellValueChanged)="onCellValueChanged($event)"
  (gridReady)="onGridReady($event)">
</ag-grid-angular>

<div class="SearchResultsAlternativesContainer animated fadeIn" *ngIf="ShowSearchResultsAlternatives === true" [ngStyle]="SearchResultsPosition">
  <div class="SearchResultsHeader">
    <span>{{'AlternativeResults' | translate}}</span>
    <button class="CloseBtn" (click)="ShowSearchResultsAlternatives = false">×</button>
  </div>
  <div class="SearchResultsList" *ngIf="this.LoadingSideOffers == true;">
    <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
  </div>
  <div class="SearchResultsList" *ngIf="this.LoadingSideOffers != true;">
    <div class="SearchResultItem" *ngFor="let result of SearchResultAlternatives" (click)="SwitchGridResultAlternative(result)" [ngClass]="{ 'SelectedItem': result.IsSelected }">
  <div class="SearchResultTitle">
    {{ result.ProductName }} {{ result.ProductPartNumber }}
    <span *ngIf="result.IsSelected" class="SelectedTag">✓ {{ 'Selected' | translate }}</span>
  </div>

  <div class="SearchResultMeta">
    <span class="SearchResultBrand">{{ result.FKBrandName }}</span>
    <!-- <span class="SearchResultPrice">
      {{ result.Price?.UIUnitPrice }} {{ result.Price?.Currency?.Name }}
    </span> -->
  </div>
  </div>
  </div>
</div>

<!-- brand-only popup -->
<div class="BrandCollateralContainer" *ngIf="ShowBrandCollateral == true" [ngStyle]="BrandPopupPosition">
  <div class="SearchResultsList" *ngIf="LoadingSideOffers === true" style="margin-top: 50px; margin-bottom: 50px; overflow: hidden;">
    <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
  </div>
  <div *ngIf="LoadingSideOffers != true;" class="SearchResultsList" style="overflow: hidden;">
 <!-- render your brands here -->
    <div class="brand-collateral-item" *ngFor="let b of BrandCollateralList" (click)="SwitchGridBrandVersion2(b);">
      <span>{{ b?.Name}}</span>
      <i class="material-icons" *ngIf="b.IsSelected == true;">check</i>
    </div>
  </div>
</div>

<!-- brand-only popup -->
<div class="BrandCollateralContainer" *ngIf="ShowBrandCollateralNewProduct == true" [ngStyle]="BrandPopupPosition">
  <div class="SearchResultsList" *ngIf="LoadingSideOffers === true" style="margin-top: 50px; margin-bottom: 50px; overflow: hidden;">
    <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
  </div>
  <div *ngIf="LoadingSideOffers != true;" class="SearchResultsList" style="overflow: hidden;">
 <!-- render your brands here -->
    <div class="brand-collateral-item" *ngFor="let b of BrandSelectList" (click)="AttachBrandToNewProduct(b);">
      <span>{{ b?.Name}}</span>
      <i class="material-icons" *ngIf="b.IsSelected == true;">check</i>
    </div>
  </div>
</div>

<div class="SearchResultsAlternativesContainer grid-style-popup animated fadeIn"
     *ngIf="ShowFallbackSelection === true"
     [ngStyle]="SearchResultsPosition">

  <div class="SearchResultsHeader" *ngIf="LoadingSideOffers !== true">
    <span>{{ 'PleaseChooseAnItem' | translate }}</span>
    <button class="CloseBtn" (click)="ShowFallbackSelection = false">×</button>
  </div>

  <div class="SearchResultsList" *ngIf="LoadingSideOffers === true" style="margin-top: 50px; margin-bottom: 50px;">
    <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
  </div>

  <div class="SearchResultsList" *ngIf="LoadingSideOffers !== true">
    <div class="OfferRow">
      <div class="GridCell indexx-column" style="font-style: italic;">
        #
      </div>   
      <div class="GridCell brand-column" style="font-style: italic;">
        {{'Brand' | translate}}
      </div>     

      <div class="GridCell partnumber-column" style="font-style: italic;">
      {{'ProductCode' | translate}}
      </div>     

      <div class="GridCell name-column" style="font-style: italic;">
      {{'ProductName' |  translate}}
      </div>     

    <div class="GridCell qty-column" style="font-style: italic;">
      min.{{'Quantity' |  translate}}
    </div>

    <div class="GridCell price-column" style="font-style: italic;">
      {{'SellPrice' |  translate}}
    </div>

    <div class="GridCell total-column" style="font-style: italic;">
      {{'Total' |  translate}}
    </div>

    <div class="GridCell eta-column" style="font-style: italic;">
      {{'ETA' |  translate}}
    </div>

    <div class="GridCell hscode-column" style="font-style: italic;">
      {{'HSCode' |  translate}}
    </div>

    <div class="GridCell coo-column" style="font-style: italic;">
      {{'COO' |  translate}}
    </div>

    <div class="GridCell weight-column" style="font-style: italic;">
      {{'Weight' |  translate}}
    </div>
    <div class="GridCell x-column" style="font-style: italic;">
      
    </div>
</div>
    <div class="OfferRow"
    *ngFor="let result of FallbackOffers; index as i"
    [ngClass]="{ 'SelectedRow': result.IsSelected }"
    (click)="SwitchGridResultProduct(result)">

    <div class="GridCell indexx-column">
      {{i + 1}}
    </div>   
    <div class="GridCell brand-column">
      {{result.Product?.Brand?.Name}}
    </div>     

    <div class="GridCell partnumber-column">
      {{result.Product?.PartNumber}}
    </div>     

    <div class="GridCell name-column">
    <span>{{result.Product?.Name}}</span>
    <span class="GridCellSpecialPriceSignal" *ngIf="result.SelectedOffer?.Configuration?.SpecialPriceList == true;">({{'SpecialPriceOffer' | translate}})</span>
    </div>     

    <div class="GridCell qty-column">
    {{result.Quantity}}
    </div>

    <div class="GridCell price-column">
    <span style="float: left;" [ngClass]="{'GridCellSpecialPriceSignal': result.SelectedOffer?.Configuration?.SpecialPriceList == true}">
      <span *ngIf="result.Price?.UIUnitPrice > 0;">{{result.Price?.UIUnitPrice}} {{result.Price?.Currency?.Name}}</span>
      <span *ngIf="!(result.Price?.UIUnitPrice > 0)" class="RequestPriceGridCellButton">{{'RequestPrice' | translate}}</span>
    </span>
    </div>

    <div class="GridCell total-column">
    <span style="float: left;" [ngClass]="{'GridCellSpecialPriceSignal': result.SelectedOffer?.Configuration?.SpecialPriceList == true}">
          <span *ngIf="result.Price?.UIQtyPrice > 0;">{{result.Price?.UIQtyPrice}} {{result.Price?.Currency?.Name}}</span>
          <span *ngIf="!(result.Price?.UIQtyPrice > 0)">------- {{result.Price?.Currency?.Name}}</span>
    </span>
    </div>

    <div class="GridCell eta-column">
    <span *ngIf="result.SelectedOffer?.LeadTime?.Units > 0;">
    {{result.SelectedOffer?.LeadTime?.Units}} {{result.SelectedOffer?.LeadTime?.Type?.Name}}
    </span>
    <span *ngIf="result.SelectedOffer?.IsStockOffer == true;">(Stock)</span>
    </div>

    <div class="GridCell hscode-column">
    {{result.Product?.Stats?.HSCode}}
    </div>

    <div class="GridCell coo-column">
    {{result.Product?.Stats?.COO?.ShortName}}
    </div>

    <div class="GridCell weight-column">
    <span *ngIf="result.Product?.Stats?.Weight > 0;">
    {{result.Product?.Stats?.Weight}} {{result.Product?.Stats?.WeightMeasurementType?.Name}}
    </span>
    </div>
    <div class="GridCell x-column">

    </div>
    </div>
  </div>
</div>

<div class="SearchResultsAlternativesContainer grid-style-popup animated fadeIn"
     *ngIf="ShowETAAlternatives === true"
     [ngStyle]="SearchResultsPosition">

  <div class="SearchResultsHeader" *ngIf="LoadingSideOffers !== true">
    <span>{{ 'OtherOffers' | translate }}</span>
    <button class="CloseBtn" (click)="ShowETAAlternatives = false">×</button>
  </div>

  <div class="SearchResultsList" *ngIf="LoadingSideOffers === true" style="margin-top: 50px; margin-bottom: 50px;">
    <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
  </div>

  <div class="SearchResultsList" *ngIf="LoadingSideOffers !== true">
    <div class="OfferRow">
      <div class="GridCell indexx-column" style="font-style: italic;">
        #
      </div>   
      <div class="GridCell brand-column" style="font-style: italic;">
        {{'Brand' | translate}}
      </div>     

      <div class="GridCell partnumber-column" style="font-style: italic;">
      {{'ProductCode' | translate}}
      </div>     

      <div class="GridCell name-column" style="font-style: italic;">
      {{'ProductName' |  translate}}
      </div>     

    <div class="GridCell qty-column" style="font-style: italic;">
      min.{{'Quantity' |  translate}}
    </div>

    <div class="GridCell price-column" style="font-style: italic;">
      {{'SellPrice' |  translate}}
    </div>

    <div class="GridCell total-column" style="font-style: italic;">
      {{'Total' |  translate}}
    </div>

    <div class="GridCell eta-column" style="font-style: italic;">
      {{'ETA' |  translate}}
    </div>

    <div class="GridCell hscode-column" style="font-style: italic;">
      {{'HSCode' |  translate}}
    </div>

    <div class="GridCell coo-column" style="font-style: italic;">
      {{'COO' |  translate}}
    </div>

    <div class="GridCell weight-column" style="font-style: italic;">
      {{'Weight' |  translate}}
    </div>
    <div class="GridCell x-column" style="font-style: italic;">
      
    </div>
</div>
    <div class="OfferRow"
         *ngFor="let result of SideOffers; index as i"
         (click)="SwitchGridProductOffer(result)"
         [ngClass]="{ 'SelectedRow': result.IsSelected }">

         <div class="GridCell indexx-column">
          {{i + 1}}
        </div>   
        <div class="GridCell brand-column">
          {{result.Product?.Brand?.Name}}
        </div>     
  
        <div class="GridCell partnumber-column">
          {{result.Product?.PartNumber}}
        </div>     
  
        <div class="GridCell name-column">
          <span>{{result.Product?.Name}}</span>
          <span class="GridCellSpecialPriceSignal" *ngIf="result.SelectedOffer?.Configuration?.SpecialPriceList == true;">({{'SpecialPriceOffer' | translate}})</span>
        </div>     
  
      <div class="GridCell qty-column">
          {{result.Quantity}}
      </div>
  
      <div class="GridCell price-column">
        <span style="float: left;" [ngClass]="{'GridCellSpecialPriceSignal': result.SelectedOffer?.Configuration?.SpecialPriceList == true}">
          {{result.Price?.UIUnitPrice}} {{result.Price?.Currency?.Name}}
        </span>
      </div>
  
      <div class="GridCell total-column">
        <span style="float: left;" [ngClass]="{'GridCellSpecialPriceSignal': result.SelectedOffer?.Configuration?.SpecialPriceList == true}">
          {{result.Price?.UIQtyPrice}}  {{result.Price?.Currency?.Name}}
        </span>
      </div>
  
      <div class="GridCell eta-column">
        <span *ngIf="result.SelectedOffer?.LeadTime?.Units > 0;">
          {{result.SelectedOffer?.LeadTime?.Units}} {{result.SelectedOffer?.LeadTime?.Type?.Name}}
        </span>
        <span *ngIf="result.SelectedOffer?.IsStockOffer == true;">(Stock)</span>
      </div>
  
      <div class="GridCell hscode-column">
        {{result.Product?.Stats?.HSCode}}
      </div>
  
      <div class="GridCell coo-column">
        {{result.Product?.Stats?.COO?.ShortName}}
      </div>
  
      <div class="GridCell weight-column">
        <span *ngIf="result.Product?.Stats?.Weight > 0;">
          {{result.Product?.Stats?.Weight}} {{result.Product?.Stats?.WeightMeasurementType?.Name}}
        </span>
      </div>
      <div class="GridCell x-column">
        
      </div>
    </div>
  </div>
</div>

<div class="GridCommandCenter">
  <button mat-flat-button color="primary" class="AddRowsButton" style="color: #fff;" (click)="this.addMoreRows();">
    <i class="material-icons">add</i>
    <span>{{'AddRows' | translate}}</span>
  </button>
</div>
</div>
</div>